import push from '../../utils/routing';

// Materials is the default tab when clicking on the Journey tab.
export default (spaceId, materialSectionId) => () => {
  const url = materialSectionId
    ? `/dashboard/${spaceId}/journey/materials/${materialSectionId}`
    : `/dashboard/${spaceId}/journey/materials`;
  push(url);
};
